import { nFormatter } from "@/common/utils/parseNumber";
import LikedIcon from "@/common/images/icons/likeIcon.svg?react";
import UnlikedIcon from "@/common/images/icons/unliked.svg?react";
import "./LikeButton.scss";

interface ILikeButtonProps {
  liked: boolean;
  count: number;
  onClick: () => void;
}

export const LikeButton: React.FC<ILikeButtonProps> = ({ onClick, liked, count }) => {
  return (
    <div className="LikeButton">
      <button onClick={onClick} aria-label="toggle like button">
        {liked ? <LikedIcon /> : <UnlikedIcon />}
      </button>
      <div className="label">{nFormatter(count)}</div>
    </div>
  );
};
